import React from 'react';

/**
 * FilterBar
 */
class FilterBar extends React.Component {
  render() {
    return (
      <div className="fix_height_title dispfilterbar" id="filter_bar">
        <nobr>
          <span>
            <div className="ctrl_form_title_icon_only" />
            <div className="filter-open-btn">
              <a className="btn sort_extraction js_pw" href="#pw_extraction" id="filter_bar_btn">
                <div>
                  <span>
                    <i className="arrow_left" aria-hidden="true" />
                  </span>
                </div>
              </a>
            </div>
          </span>
        </nobr>
      </div>
    );
  }
}

export default FilterBar;
